import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { reduxForm } from "redux-form";
import Filters from "../../Utils/Filters/Filters";
import Grid from "../../Utils/Grid";
import Title from "../../Utils/Headers/Title";

import "./report-station.css";

const List = ({
    listarReport,
    data,
    loader,
    descargarExcel,
    start_date,
    setStartDate,
    end_date,
    setEndDate,
    emergency_type_id,
    setTypeEmergency,
    station,
    setStation,
    me,
    excelLoading,
    excelProgress,
}) => {
    useEffect(() => {
        listarReport();
    }, []);

    if (!me.station) {
        NotificationManager.error('No tienes una estación asignada', 'Error', 3000);
    }

    const columns = [
        {
            dataField: "no",
            sort: true,
            text: "No."
        },
        {
            dataField: "name",
            sort: true,
            text: "Estación",
        },
        {
            dataField: "emergency_type",
            sort: true,
            text: "Tipo de emergencia",
        },
        {
            dataField: "emergency_total",
            sort: true,
            text: "Total de emergencias atendidas",
            formatter: (cell, row) => (
                <div>{row.counts.emergencies} emergencias</div>
            ),
        },
        {
            dataField: "patients_total",
            sort: true,
            text: "Total de pacientes registrados",
            formatter: (cell, row) => (
                <div>{row.counts.patients} pacientes</div>
            ),
        },
    ];

    return (
        <div className="py-4">
            <div className="row">
                <div className="mb-4 col-lg-12">
                    <div className="mb-4 card card-small">
                        <div className="px-3 pt-4">
                            <Title
                                showCreate={false}
                                title={"Reporte Estaciones"}
                                subtitle={"Listado general"}
                                downoaldExcel={{
                                    title: "Descargar Excel",
                                    onClick: descargarExcel,
                                    disabled: !me.station ? true : false,
                                    loading: excelLoading,
                                    progress: excelProgress,
                                }}
                                total={{
                                    title: "Total de emergencias resueltas",
                                    subtitle: "Emergencias",
                                    total: data ? data.emergency_length : 0,
                                }}
                            />
                        </div>
                        <div className="p-0 px-3 pt-3">
                            <div className="filters-container-rrhh mb-4">
                                <div className="filters-fields-group">
                                    <Filters
                                        startDate={{
                                            show: true,
                                            start_date: start_date,
                                            setStartDate: setStartDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                        }}
                                        endDate={{
                                            show: true,
                                            end_date: end_date,
                                            setEndDate: setEndDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                        }}
                                        emergency_type={{
                                            show: true,
                                            multi: true,
                                            emergency_type: emergency_type_id,
                                            nameApiOptions: 'category_emergency_type',
                                            setTypeEmergency: setTypeEmergency,
                                            classNameFilter: "flex-1 filter-wrapper",
                                        }}
                                        station={{
                                            show: true,
                                            station: station,
                                            setStation: setStation,
                                            classNameFilter: "flex-1 filter-wrapper",
                                        }}
                                    />
                                </div>
                            </div>
                            <Grid
                                data={data}
                                loading={loader}
                                columns={columns}
                                onPageChange={listarReport}
                                noDataMessage={"No hay emergencias resueltas."}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default reduxForm({
    form: "ListReportStation", // a unique identifier for this form
})(List);

// export default List;
